/**
 * The prediction module's paths.
 *
 * `windowDays` lives on the URL rather than in component state for the reason the
 * maintenance board's horizon does: a count of "two vehicles at high stress" is
 * meaningless without the window it counted over, and two managers reading the same
 * screen with different windows both believe they are looking at the fleet's quarter.
 */

export const PREDICTIONS_PATH = '/predictions'

export const PREDICTION_QUERY_KEYS = {
  windowDays: 'window',
  fleetId: 'fleet',
  /** Which vehicle's detail is expanded, so a finding forwards as a link. */
  selected: 'vehicle',
} as const

export function predictionsPath(vehicleId?: string): string {
  return vehicleId === undefined
    ? PREDICTIONS_PATH
    : `${PREDICTIONS_PATH}?${PREDICTION_QUERY_KEYS.selected}=${vehicleId}`
}
